// extracted by mini-css-extract-plugin
export var blog = "BlogRoll-module--blog--BM-xS";
export var blogLink = "BlogRoll-module--blog-link--iT7RM";
export var details = "BlogRoll-module--details--PMmxU";
export var fadeInBlog = "BlogRoll-module--fade-in-blog--kYJwk";
export var image = "BlogRoll-module--image--3PV4X";
export var minutes = "BlogRoll-module--minutes--hh+uF";
export var text = "BlogRoll-module--text--EuNvw";